import cloneDeep from 'lodash/cloneDeep'

import baseDefaults from '../Base/Base.defaults'

export default {
  
  ...cloneDeep(baseDefaults),

  title: {
    tagName: 'h1',
    variant: 'mediumHeading',
    text: 'Your title here!',
    color: undefined
  }
}